import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import ClearRoundedIcon from "@material-ui/icons/ClearRounded";
import ExlyImage from "common/Components/ExlyImage";
import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import React from "react";

export const NOTE_STATUS = {
  SUCCESS: 1,
  WARNING: 2,
  ERROR: 3,
  ABOUT_COMPLETED: 4,
};

export const NOTE_ROOT_CLASSES = {
  [NOTE_STATUS.SUCCESS]: "tw-bg-[#D4FFF0]",
  [NOTE_STATUS.WARNING]: "tw-bg-[#FFF3D9]",
  [NOTE_STATUS.ERROR]: "tw-bg-[#FBEBEA]",
  [NOTE_STATUS.ABOUT_COMPLETED]: "tw-bg-[#FFF3D9]",
};

export const NOTE_HEADER_CLASSES = {
  [NOTE_STATUS.SUCCESS]: "tw-text-[#03b77a]",
  [NOTE_STATUS.WARNING]: "tw-text-[#ffbc2b]",
  [NOTE_STATUS.ERROR]: "tw-text-[#bf2600]",
  [NOTE_STATUS.ABOUT_COMPLETED]:
    "tw-bg-[linear-gradient(94deg,#2c207e_-10.84%,#7369ef_44.25%,#2c207e_95.13%)] tw-bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]",
};

export const NOTE_INFO_CLASSES = {
  [NOTE_STATUS.ABOUT_COMPLETED]: "tw-text-[#493AB1CC]",
};

export const NOTE_HEADER_ICON = {
  [NOTE_STATUS.SUCCESS]: (
    <CheckRoundedIcon className="tw-text-[18px] tw-mr-[5px]" />
  ),
  [NOTE_STATUS.WARNING]: (
    <ExlyImage
      src={getS3AssetCDNUrl("assets/vectors/common/star_loader.svg")}
      className="tw-text-[18px] tw-mr-[5px]"
    />
  ),
  [NOTE_STATUS.ABOUT_COMPLETED]: (
    <ExlyImage
      src={getS3AssetCDNUrl("assets/vectors/common/pie.svg")}
      className="tw-text-[18px] tw-mr-[5px]"
    />
  ),
  [NOTE_STATUS.ERROR]: (
    <ClearRoundedIcon className="tw-text-[18px] tw-mr-[5px]" />
  ),
};
